<script>
import GuideView from '../guide/guide-view'
import getViewConfig from './guide-step-view-config'

export default {
    name: 'GuideStepView',
    // -------------------------------- Extends -------------------------------------
    extends: GuideView,
    // -------------------------------- Computed ------------------------------------
    computed:{
        guideStepViewConfig() {
            return getViewConfig()
        }
    },

    methods:{
        beforeGoToView(){
            this.highlightUnits()
            this.highlightGuideStep(this.centerOnGuideSteps[0])
        },
    },
    created(){
        //Each child view should call this method to include their view config prop name to inheritance collection
        this.addInheritedView('guideStepViewConfig')
    },
}
</script>
